// @flow
import { Fragment } from 'react';
import Carousel from '../ImageAndText';

import ExternalElementPopup from '../../popups/ExternalElementPopup';

const shallowImage = '/images/diamond-education/shallow_diamond_cut.jpg';
const deepImage = '/images/diamond-education/deep_diamond_cut.jpg';
const correctImage = '/images/diamond-education/correct_diamond_cut.jpg';

const items = [
  {
    headerText: 'Shallow Cut',
    component: (
      <Fragment>
        If the diamond cut is too shallow, entering light strikes the{' '}
        <span
          className="text-link text-underline"
          data-popup="diamond-cut-proportions-carousel--pavilion-1"
          role="button"
          tabIndex="0">
          pavilion
        </span>{' '}
        facet at a low angle and passes through the facet (refracts), escaping
        through the bottom of the diamond.
        <ExternalElementPopup
          name="Pavilion"
          selector="diamond-cut-proportions-carousel--pavilion-1"
        />
      </Fragment>
    ),
    imageUrl: shallowImage,
    imageLocation: 'top',
    imageAlt: 'Shallow Diamond Cut',
    imageStyles: {
      marginLeft: 43,
      marginTop: 12,
      height: 107,
      width: 122
    }
  },
  {
    headerText: 'Deep Cut',
    text: `If the diamond cut is too deep, entering light strikes the first pavilion facet at an angle sharp enough to reflect to the
      second pavilion. But the light strikes the second pavilion at too low an angle, causing the light to refract
      (pass through the facet), escaping through the bottom of the diamond.`,
    imageUrl: deepImage,
    imageLocation: 'left',
    imageAlt: 'Deep Diamond Cut',
    imageStyles: {
      marginLeft: 43,
      marginRight: 1,
      marginTop: 15,
      height: 90,
      width: 121
    }
  },
  {
    headerText: 'Well Cut',
    component: (
      <Fragment>
        In a well cut diamond, the light strikes each pavilion facet at an angle
        which allows most of the light to reflect back to the crown (top). As it
        passes through the crown facets at a low angle, the light refracts upon
        exit. In this case, refraction is a good thing, as the bent light
        travels to the observer's eye and is perceived as a lively{' '}
        <span
          className="text-link text-underline"
          data-popup="diamond-cut-proportions-carousel--fire-1"
          role="button"
          tabIndex="0">
          fire
        </span>
        <ExternalElementPopup
          name="Fire"
          selector="diamond-cut-proportions-carousel--fire-1"
        />
        .
      </Fragment>
    ),
    imageUrl: correctImage,
    imageLocation: 'left',
    imageAlt: 'Correct Diamond Cut',
    imageStyles: {
      marginLeft: 43,
      marginTop: 2,
      height: 100,
      width: 122
    }
  }
];

const DiamondCutProportions = (props: Object) => {
  return <Carousel {...props} items={items} />;
};

export default DiamondCutProportions;
